import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Stack, Typography } from '@mui/material';
import { camelCase } from 'lodash';
import { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';

import { DemoServiceStatusMessageCatalog } from '@/components/spotter/TelemetryServiceStatusMessage';
import { DemoOtaIneligibleAlertCatalog } from '@/components/spotter/statusTab/NotOtaEligibleAlert';
import { DemoPaymentAlertCatalog } from '@/components/subscriptions/PaymentTroubleAlert';
import { DemoInlineAlertCatalog } from '@/components/ui/InlineAlert';
import { useFeatureFlag } from '@/hooks/useFeatureFlag';

export const UiDemo = () => {
    const uiDemoFlag = useFeatureFlag('uiDemo');

    if (!uiDemoFlag) {
        return false;
    }

    return (
        <Stack maxWidth="lg" sx={{ mx: 'auto', my: 2 }}>
            <UiDemoAccordion title="Alert severities">
                <DemoInlineAlertCatalog />
            </UiDemoAccordion>
            <UiDemoAccordion title="Payment alerts">
                <DemoPaymentAlertCatalog />
            </UiDemoAccordion>
            <UiDemoAccordion title="Service status messages">
                <DemoServiceStatusMessageCatalog />
            </UiDemoAccordion>
            <UiDemoAccordion title="OTA ineligible alerts">
                <DemoOtaIneligibleAlertCatalog />
            </UiDemoAccordion>
        </Stack>
    );
};

const UiDemoAccordion = ({ title, children }: { title: string; children: ReactNode }) => {
    const { hash } = useLocation();
    const id = camelCase(title);
    const myHash = `#${id}`;
    return (
        <Accordion
            id={id}
            defaultExpanded={myHash === hash}
            onChange={(_event, isExpanded) => {
                if (isExpanded) {
                    location.hash = myHash;
                }
            }}
        >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="h4">{title}</Typography>
            </AccordionSummary>
            <AccordionDetails>{children}</AccordionDetails>
        </Accordion>
    );
};
